export enum Color {
  blue = 'blue',
  brand = 'brand',
  green = 'green',
  gray = 'gray',
  orange = 'orange',
  pink = 'pink',
  purple = 'purple',
  red = 'red',
  teal = 'teal',
  yellow = 'yellow',
}
